import React, { useState } from 'react';
import { useMarkingContext } from '../MarkingContext/MarkingContext';
import DialogClasses from './DialogClasses';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Typography from '@mui/material/Typography';

const ButtonClasses = () => {
  const { isLoading, filter, onFilter } = useMarkingContext();
  const [modal, setModal] = useState(false);

  const onClear = (e) => {
    e.stopPropagation();
    onFilter({ classId: null, classCode: null });
  }

  return (
    <>
      <div className='flex flex-wrap gap-4 items-center'>
        <div
          onClick={isLoading ? undefined : () => setModal(true)}
          className={[
            'min-w-150px max-w-150px flex items-center border border-muted rounded h-10',
            isLoading ? ' opacity-50' : ' cursor-pointer bg-clickeabled'
          ]}
        >
          <div className='h-10 w-10 justify-center flex items-center bg-muted'>
            <FontAwesomeIcon icon='search' size='lg' className='text-muted-foreground opacity-75' />
          </div>
          <div className='flex justify-between w-full px-2 items-center'>

          {filter.classCode ? 
            <Typography className='text-primary text-lg font-bold '>
              {filter.classCode}
            </Typography> : 
            <Typography className='text-muted-foreground opacity-75'>
              Find class
            </Typography>
          }
          {filter.classCode && (
            <div className='justify-center flex items-center ' onClick={onClear}>
              <FontAwesomeIcon icon={['fal', 'times']} size='lg' className='text-muted-foreground opacity-75' />
            </div>
          )}
          </div>
        </div>
      </div>
      {modal && (
        <DialogClasses
          open={modal}
          onClose={() => setModal(null)}
          setFilterId={(value) => onFilter({ ...value })}
          classId={filter?.classId}
        />
      )}
    </>
  );
};

export default ButtonClasses;
